
import { Vue } from 'vue-class-component';

export default class MenuIcon extends Vue {}
